module.exports = "/packs/009-10acaaa4e2388b121ac68c217e2606c2.jpg";